import { render, staticRenderFns } from "./ChipNumbers.vue?vue&type=template&id=289c0995&scoped=true"
import script from "./ChipNumbers.vue?vue&type=script&lang=js"
export * from "./ChipNumbers.vue?vue&type=script&lang=js"
import style0 from "./ChipNumbers.vue?vue&type=style&index=0&id=289c0995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c0995",
  null
  
)

export default component.exports